import { render, staticRenderFns } from "./GuideList.vue?vue&type=template&id=33c3a272&scoped=true&"
import script from "./GuideList.vue?vue&type=script&lang=js&"
export * from "./GuideList.vue?vue&type=script&lang=js&"
import style0 from "./GuideList.vue?vue&type=style&index=0&id=33c3a272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3a272",
  null
  
)

export default component.exports